export default "__VITE_ASSET__BEu_bvSr__"